import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';

@Component({
  selector: 'app-enqassigned',
  templateUrl: './enqassigned.component.html',
  styleUrls: ['./enqassigned.component.css']
})
export class EnqassignedComponent implements OnInit {
  data: any;

  constructor(private tenderingServices: TenderingService, private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getEnquiryList();
  }

  getEnquiryList() {
    this.tenderingServices.GetAssignedQuotes().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  sendTechQuote = function (id) {
    //alert(id);
    this.router.navigate(['/submittechquote/' + id + '']);
  }
  sendPriceQuote = function (id) {
    this.router.navigate(['/submitpricequote/' + id + '']);
  }
  sendBoth = function (id) {
    //alert(id);
    this.router.navigate(['/sentpricequotes/' + id + '']);
  }
  enqsubmittedsearch(keyword) {
    this.tenderingServices.EnqSubmittedSearch(keyword).subscribe(
      (data) => {
        this.data = data;
        console.log(data);
      }

    );
  }
}